import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_42: FaireProductEntity = {
  token: "starter_collection_42",
  type: "product",
  name: "Seashell Spoons Mini Set",
  brandName: "Be Home",
  imageUrl: "",
  priceDollars: 24,
  msrpDollars: 48,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
